require("./bodies/index.js");

Vue.component(
    "manage-salepage-body-component",
    require("./ManageSalePageBody.vue").default
);
